import { IStorageTransform } from './types';

export default class JSONTransform<T> implements IStorageTransform<T> {
  toTargetType(data: string): T {
    return JSON.parse(data);
  }

  toString(data: T): string {
    return JSON.stringify(data);
  }
}
